import styled from "styled-components";
import { Icon, ICON_SIZES } from "src/apps/components/icon/Icon";
import { ICON_PATHS } from "src/apps/components/icon/IconSVGPaths";

import { colors } from "@permisso/permisso-components";

interface ChevronIconProps {
  rotated: boolean;
  color?: string;
  size?: ICON_SIZES;
}

export const ChevronIcon = ({
  rotated,
  color = colors.grey700,
  size = ICON_SIZES.s24,
}: ChevronIconProps) => {
  return (
    <StyledChevronIcon rotated={rotated}>
      <Icon size={size} color={color} path={ICON_PATHS.CHEVRON} />
    </StyledChevronIcon>
  );
};

const StyledChevronIcon = styled.div<{ rotated: boolean }>`
  display: flex;
  transform: rotate(${({ rotated }) => (rotated ? "180deg" : "0deg")});
  transition: transform 0.2s ease-in-out;
`;
